export default __webpack_public_path__ + "static/media/movie1.1e0eb237.mp4";